/**
 * 组件信息
 */
export const info = {
  name: 'xy-stepper', // 组件名
  type: 'component-base', // 组件类型
  label: '计数器', // 组件label
  icon: 'icon-xy-stepper', // 组件图标
  defaultWidth: 240, // 组件默认宽度
  defaultHeight: 78 // 组件默认宽度
}

/**
 * 组件默认参数
 */
export const defaultProps = {
  number: {
    type: Number,
    default: 1
  },
  max: {
    type: Number,
    default: 999
  },
  min: {
    type: Number,
    default: 1
  },
  interval: {
    type: Number,
    default: 1
  }
}

/**
 * 组件开放数据源
 */
export const dataSource = [
  {
    label: '数值',
    keys: 'value'
  }
]

/**
 * 组件属性编辑表单信息
 */
export const editer = [
  {
    type: 'xy-form-input-number', // 表单组件
    label: '默认值', // 表单名称
    propKey: 'number' // 表单model字段名称
  },
  {
    type: 'xy-form-input-number', // 表单组件
    label: '最大值', // 表单名称
    propKey: 'max', // 表单model字段名称
    isActivityData: true // 是否为动态数据
  },
  {
    type: 'xy-form-input-number', // 表单组件
    label: '最小值', // 表单名称
    propKey: 'min' // 表单model字段名称
  },
  {
    type: 'xy-form-input-number', // 表单组件
    label: '加减步长', // 表单名称
    propKey: 'interval' // 表单model字段名称
  }
]
